import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
    settingsData: [],
    groupedSettings: {},
    isLoading: false,
    error: "",
    successMessage: ""
};

const siteSettingsSlice = createSlice({
    name: 'siteSettings',
    initialState,
    reducers: {
        setSiteSettings: (state, action) => {
            state.settingsData = action.payload;
            state.isLoading = false;
            state.error = "";
        },
        setGroupedSettings: (state, action) => {
            state.groupedSettings = action.payload;
            state.isLoading = false;
            state.error = "";
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.isLoading = false;
        },
        clearError: (state) => {
            state.error = "";
        },
        setLoading: (state) => {
            state.isLoading = true;
        },
        setSuccess: (state, action) => {
            state.successMessage = action.payload;
            state.isLoading = false;
        },
        clearSuccess: (state) => {
            state.successMessage = "";
        }
    },
});

export const {
    setSiteSettings,
    setGroupedSettings,
    setError,
    clearError,
    setLoading,
    setSuccess,
    clearSuccess
} = siteSettingsSlice.actions;

// Fetch site settings for admin (authenticated)
export const fetchSiteSettingsAdmin = (accessToken) => async (dispatch) => {
    dispatch(setLoading());
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/site-settings`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        dispatch(setSiteSettings(response.data.data));
    } catch (error) {
        dispatch(setError(error?.response?.data?.message || "Failed to fetch site settings"));
    }
};

// Fetch site settings for public (home page)
export const fetchSiteSettingsPublic = () => async (dispatch) => {
    dispatch(setLoading());
    try {
        const response = await axios.get(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/site-settings/public`
        );
        dispatch(setGroupedSettings(response.data.data));
    } catch (error) {
        console.error("Failed to fetch public site settings:", error);
    }
};

// Update site settings (SUPADM only)
export const updateSiteSettings = (settings, accessToken) => async (dispatch) => {
    dispatch(setLoading());
    try {
        await axios.put(
            `${process.env.REACT_APP_BACKEND_BASE_URL}/site-settings`,
            { settings },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        );
        dispatch(setSuccess("Site settings updated successfully"));
        // Refetch settings after update
        dispatch(fetchSiteSettingsAdmin(accessToken));
    } catch (error) {
        dispatch(setError(error?.response?.data?.message || "Failed to update site settings"));
    }
};

export default siteSettingsSlice.reducer;
